import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { formatDollars } from "../utils/formatAmounts";

ChartJS.register(ArcElement, Tooltip, Legend);

interface Props {
  data: {
    name: string;
    amount: number;
  }[];
}

const colors = ["#D8903C", "#813CD8", "#82F9B9", "#F06666", "#3C68D8"];

export const PieChart = ({ data }: Props) => {
  const sortedData = data
    .sort((x, y) => {
      if (x.amount < y.amount) {
        return 1;
      } else if (x.amount > y.amount) {
        return -1;
      }
      return 0;
    })
    .slice(0, 5);

  const chartData = {
    datasets: [
      {
        data: sortedData.map((d) => d.amount),
        backgroundColor: colors,
        hoverOffset: 4,
      },
    ],
  };

  return (
    <>
      <div className="h-100 flex w-[200px] justify-center pr-10">
        <Doughnut
          data={chartData}
          width={130}
          height={130}
          options={{
            elements: {
              arc: {
                borderWidth: 0,
              },
            },
            events: [],
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                enabled: false,
              },
            },
            cutout: "75%",
            maintainAspectRatio: false,
          }}
        />
      </div>
      <div className="m-auto flex h-full w-full flex-col justify-center">
        {sortedData.map((entry, i) => (
          <div className="flex justify-between pb-1" key={entry.name}>
            <div>
              <span style={{ color: colors[i] }}>•</span> {entry.name}
            </div>
            <div className="text-slate">{formatDollars(entry.amount)}</div>
          </div>
        ))}
      </div>
    </>
  );
};
